import React, { useState } from 'react';
import { Modal, ModalBody } from 'reactstrap';

import { useSuccessPopupStyles } from './useSuccessPopupStyles';
import { useApolloClient } from '@apollo/client';
import face from '../images/face.png';
import fingerprint from '../images/fingerprint.png';
import { biometricsPreferenceApi } from './loginOperation.api';
import { registerBiometricCredentials } from '../redesign-5.2/biometrics/biometrics.util';

import SuccessPopup from './SuccessPopup';
import MyEirErrorHandle from '../eir-porting/MyEirErrorHandle';

const OptInOptOutPopup = props => {
    const [isopen, setIsOpen] = useState(props.open);
    const [showSuccess, setShowSuccess] = useState(false);
    const [openError, setOpenError] = useState(false);
    const [isEnabled, setIsEnabled] = useState(false);
    const toggle = () => setIsOpen(!isopen);
    const graphql = useApolloClient();
    const classes = useSuccessPopupStyles();

    const handleSkip = async () => {
        try {
            const data = await biometricsPreferenceApi({
                graphql,
                deviceId: props.deviceId,
                biometricsPreference: false,
            });
            if (data) {
                // sessionStorage.setItem('Enable_biometrics', false);
                sessionStorage.setItem('Biometrics_opted_in', false);
            }
            setShowSuccess(true);
        } catch (e) {
            console.error('skip biometrics failed:', e);
            setOpenError(true);
        }
    };

    const handleEnableBiometrics = async () => {
        try {
            await registerBiometricCredentials({
                graphql,
                username: props.username,
                deviceId: props.deviceId,
            });
            // Polling sessionStorage for key Biometrics_enrollment_status is set
            const checkEnrollmentStatus = () => {
                const enrollmentStatus = sessionStorage.getItem('Biometrics_enrollment_status');
                if (enrollmentStatus === null) {
                    setTimeout(checkEnrollmentStatus, 500);
                }
                if (enrollmentStatus === 'success') {
                    sessionStorage.setItem('Biometrics_opted_in', true);
                    setShowSuccess(true);
                    setIsEnabled(true);
                } else if (enrollmentStatus === 'failed') {
                    console.log('biometrics enrolment failed');
                    sessionStorage.setItem('Biometrics_opted_in', false);
                    setOpenError(true);
                }
            };
            checkEnrollmentStatus();
            // console.log('register status:', status);
            // if (status) {
            //     sessionStorage.setItem('Biometrics_opted_in', true);
            //     setShowSuccess(true);
            //     setIsEnabled(true);
            // }
        } catch (e) {
            // sessionStorage.setItem('Enable_biometrics', false);
            sessionStorage.setItem('Biometrics_opted_in', false);
            console.error('enable biometrics failed:', e);
            setOpenError(true);
        }
    };

    return (
        <React.Fragment>
            <Modal
                className={classes.successMain}
                wrapClassName={classes.successMainWrapper}
                modalClassName={classes.successMainModal}
                backdropClassName={classes.successMainBackDrop}
                contentClassName={classes.successMainContent}
                isOpen={isopen}
                toggle={toggle}
                modalTransition={{ timeout: 300 }}
                centered
            >
                <ModalBody className={classes.successWrapper}>
                    <div className={classes.registerTitleContainer}>
                        <div className={classes.registerTitle}>Quick & secure access</div>
                    </div>
                    <div className={classes.successBody}>
                        <div className={classes.tickWrapper}>
                            <img
                                className={classes.tick}
                                src={props.flag === 'iOS' ? face : fingerprint}
                                alt=''
                            />
                        </div>
                        <div className={classes.newsTextWrapper}>
                            <div className={classes.newsText}>{props.subText1}</div>
                            <div className={classes.newsText}>{props.subText2}</div>
                            <div className={classes.newsText} style={{ fontWeight: 700 }}>
                                {props.subText3}
                            </div>
                        </div>
                    </div>
                    <div className={classes.successFooter}>
                        <button
                            tabindex='0'
                            role='button'
                            aria-label={
                                props.flag === 'iOS'
                                    ? 'Enable Face ID login'
                                    : "Secure login option using your device's biometrics"
                            }
                            className={'primary-cta footer-cta'}
                            onClick={handleEnableBiometrics}
                        >
                            {props.ctaText}
                        </button>
                        <button
                            tabindex='0'
                            role='button'
                            className={'secondary-cta footer-cta'}
                            onClick={handleSkip}
                            aria-label={
                                props.flag === 'iOS' ? 'Skip Face ID setup' : 'Skip biometric setup'
                            }
                        >
                            Skip for now
                        </button>
                    </div>
                </ModalBody>
            </Modal>

            {showSuccess ? (
                <SuccessPopup
                    open={showSuccess}
                    setOpen={setShowSuccess}
                    text={
                        isEnabled
                            ? 'Your biometric login has been set up. This will be your new method to login in.'
                            : "Your device has been successfully verified. You're now securely signed in."
                    }
                    prepay={props.prepay}
                />
            ) : (
                ''
            )}
            {openError ? <MyEirErrorHandle open={openError} setOpen={setOpenError} /> : ''}
        </React.Fragment>
    );
};

export default OptInOptOutPopup;
